export const BaseUrl = import.meta.env.VITE_BASEURL || 'https://ourimpacthub-graphql.azurewebsites.net'
export const ImageServerUrl =  BaseUrl + import.meta.env.VITE_IMAGESERVER
export const GraphqlServerUrl = BaseUrl + import.meta.env.VITE_C2S_GRAPHQL_URL
export const SearchServerUrl = BaseUrl + import.meta.env.VITE_C2S_SEARCH_URL
